<template>
    <v-col cols="12" class="card card-front zoom-card">
      <v-row class="section-image">
        <v-img
          class="image-card"
          v-bind:src="url_logo"
          height="179px"
          max-width="100%"
          cover
        >
        </v-img>
      </v-row>

      <v-row class="section-title-gallery">
      <p class="section-text-gallery">
        {{ data.title }}
      </p>
    </v-row>

      <v-row class="section-stand">
      
        <v-btn
          :color="color_category"
          :style="{ color: (project_gallery_mode)?'white':'black' }"
          small
          dark
          :to="{ name: 'showProject', params: { slug: data.slug } }"
        >
          Ver Stand
        </v-btn>

      </v-row>

      <v-row class="section-social">
        <v-btn
          icon
          large 
          :color="(data.userLiked)?'red':'balck'"
          :loading="loading_btn"
          @click="handleLike(data)"
        >
          <v-icon>mdi-heart</v-icon>
        </v-btn>
        <label><small>{{ data.likes }}</small></label>
      </v-row>
    </v-col>

</template>
<script>
  import axios from 'axios'
  const VUE_URL_API = process.env.VUE_APP_URL_API
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'cardProjectGallery',
    props:['data', 'color_category', 'project_gallery_mode'],

    data: () => ({
      show_card:false,
      loading:false,
      loading_btn: false,

      url_logo:null,
      base_url: null
    }),

    methods:{    
      createURL(){
        this.url_logo = this.base_url + this.data.logo
        this.show_card = true
      },

      truncate(str, length) {
        if (str.length > length) {
          return str.slice(0, length) + '...';
        } else return str;
      },

      async handleLike(data){
        console.log(data)
        this.loading_btn = true

        this.loading_download=true
        this.url = VUE_URL_API + '/participant/entrepreneurship-windows/'+this.data.slug+'/like'
        await axios.put(
          this.url, 
        ).then((response) => {
          console.log(response)

          if(!this.data.userLiked){
            this.data.userLiked = true
            this.data.likes++
          }else{
            this.data.userLiked = false
            this.data.likes--
          }

          this.loading_btn = false
        })
      }
    },
    created() {
      this.base_url = APP_URL
      this.createURL()
    }
  }
</script>

<style type='text/css' scoped>
.zoom-card {
  transition: transform .2s; /* Animation */
}

.zoom-card:hover {
  transform: scale(1.03); /* (20% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.card {
  outline: 1px solid #E0E0E0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 240px!important;
  height: 324px;
  background-color: #ffffff;
  border-radius: 8px;
  line-height: 27px;
  position: relative;
  color: #000000;
  box-shadow: 0 0 15px rgb(0 0 0 / 0.2);
}
.card-front {
  display: block;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
}

.img-flag{
  height: auto;
  max-width: 30px;
}
.section-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
  border-bottom: 1px solid #E0E0E0;
}

.image-card {
  border-top-right-radius: 8px 8px;
  border-top-left-radius: 8px 8px;
}

.section-title-gallery {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 4px 4px 4px;
}

.section-text-gallery {
  /* Configuración para limitar a 2 líneas con truncado */
  display: -webkit-box; /* Flexbox para WebKit */
  -webkit-box-orient: vertical; 
  -webkit-line-clamp: 2; /* Limita a 2 líneas */
  line-clamp: 2;
  overflow: hidden; /* Oculta el texto adicional */

  /* Asegura que los puntos suspensivos se muestren */
  text-overflow: ellipsis; 
  white-space: normal; /* Permite el salto de línea */

  /* Ajustes de espaciado entre líneas */
  line-height: 1.3em; 
  max-height: 3.2em; /* Altura máxima para 2 líneas */
}

.section-stand {
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  height: 46px;
}

.section-social {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
}
</style>